<div class="theme-custom">
    <div #screen id="capture">
        <header class="m-grid__item m-header" data-minimize="false" [attr.data-minimize]="ui.getIsMenuMinimizable()"
            [attr.data-minimize-mobile]="ui.getIsMenuMinimizableMobile()" data-minimize-offset="200"
            data-minimize-mobile-offset="200">
            <style>
                @media (max-width: 480px) {
                    .m-topbar .m-topbar__nav.m-nav>.m-nav__item>.m-nav__link .m-topbar__userpic img {
                        width: 25px;
                        height: 25px;
                    }
                }

                /* @media (max-width: 375px) {
                    .flex-gap-half {
                        margin-left: auto !important;
                    }
                } */

                .multiActionIcon {
                    padding: 10px 1.15rem;
                    background-color: white;
                    border: 1px #777c9d solid;
                    color: #2C77E8 !important;
                    margin-right: 3px;
                }

                /* :not(:required) hides these rules from IE9 and below */
                .loading:not(:required) {
                    /* hide "loading..." text */
                    font: 0/0 a;
                    color: transparent;
                    text-shadow: none;
                    background-color: transparent;
                    border: 0;
                }

                .loading:not(:required):after {
                    content: '';
                    display: block;
                    font-size: 10px;
                    width: 1em;
                    height: 1em;
                    margin-top: -0.5em;
                    -webkit-animation: spinner 1500ms infinite linear;
                    -moz-animation: spinner 1500ms infinite linear;
                    -ms-animation: spinner 1500ms infinite linear;
                    -o-animation: spinner 1500ms infinite linear;
                    animation: spinner 1500ms infinite linear;
                    border-radius: 0.5em;
                    -webkit-box-shadow: rgba(0, 0, 0, 0.75) 1.5em 0 0 0, rgba(0, 0, 0, 0.75) 1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) 0 1.5em 0 0, rgba(0, 0, 0, 0.75) -1.1em 1.1em 0 0, rgba(0, 0, 0, 0.5) -1.5em 0 0 0, rgba(0, 0, 0, 0.5) -1.1em -1.1em 0 0, rgba(0, 0, 0, 0.75) 0 -1.5em 0 0, rgba(0, 0, 0, 0.75) 1.1em -1.1em 0 0;
                    box-shadow: rgba(0, 0, 0, 0.75) 1.5em 0 0 0, rgba(0, 0, 0, 0.75) 1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) 0 1.5em 0 0, rgba(0, 0, 0, 0.75) -1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) -1.5em 0 0 0, rgba(0, 0, 0, 0.75) -1.1em -1.1em 0 0, rgba(0, 0, 0, 0.75) 0 -1.5em 0 0, rgba(0, 0, 0, 0.75) 1.1em -1.1em 0 0;
                }

                .m-nav.m-nav--inline>.m-nav__item {
                    display: unset !important;
                }

                .m-topbar .m-topbar__nav.m-nav>.m-nav__item>.m-nav__link .m-nav__link-icon {
                    display: contents;
                }

                .m-topbar .m-topbar__nav.m-nav>.m-nav__item>.m-nav__link .m-nav__link-icon>i:before {
                    background: linear-gradient(180deg, #2c77e8 25%, #2c77e8 50%, #2c77e8 75%, #2c77e8 100%);
                    -webkit-background-clip: text;
                    background-clip: text;
                }

                .m-topbar .m-topbar__nav.m-nav>.m-nav__item>.m-nav__link .m-nav__link-badge {
                    left: auto;
                    position: absolute;
                    top: 0;
                    width: 15px;
                    height: 15px;
                    right: -7px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                /* Animation */

                @-webkit-keyframes spinner {
                    0% {
                        -webkit-transform: rotate(0deg);
                        -moz-transform: rotate(0deg);
                        -ms-transform: rotate(0deg);
                        -o-transform: rotate(0deg);
                        transform: rotate(0deg);
                    }

                    100% {
                        -webkit-transform: rotate(360deg);
                        -moz-transform: rotate(360deg);
                        -ms-transform: rotate(360deg);
                        -o-transform: rotate(360deg);
                        transform: rotate(360deg);
                    }
                }

                @-moz-keyframes spinner {
                    0% {
                        -webkit-transform: rotate(0deg);
                        -moz-transform: rotate(0deg);
                        -ms-transform: rotate(0deg);
                        -o-transform: rotate(0deg);
                        transform: rotate(0deg);
                    }

                    100% {
                        -webkit-transform: rotate(360deg);
                        -moz-transform: rotate(360deg);
                        -ms-transform: rotate(360deg);
                        -o-transform: rotate(360deg);
                        transform: rotate(360deg);
                    }
                }

                @-o-keyframes spinner {
                    0% {
                        -webkit-transform: rotate(0deg);
                        -moz-transform: rotate(0deg);
                        -ms-transform: rotate(0deg);
                        -o-transform: rotate(0deg);
                        transform: rotate(0deg);
                    }

                    100% {
                        -webkit-transform: rotate(360deg);
                        -moz-transform: rotate(360deg);
                        -ms-transform: rotate(360deg);
                        -o-transform: rotate(360deg);
                        transform: rotate(360deg);
                    }
                }

                @keyframes spinner {
                    0% {
                        -webkit-transform: rotate(0deg);
                        -moz-transform: rotate(0deg);
                        -ms-transform: rotate(0deg);
                        -o-transform: rotate(0deg);
                        transform: rotate(0deg);
                    }

                    100% {
                        -webkit-transform: rotate(360deg);
                        -moz-transform: rotate(360deg);
                        -ms-transform: rotate(360deg);
                        -o-transform: rotate(360deg);
                        transform: rotate(360deg);
                    }
                }
            </style>
            <div class="m-header__top">

                <div class="m-container {{ui.getContainerClass()}} m-container--xxl m-container--full-height">
                    <div class="m-stack m-stack--ver m-stack--desktop">
                        <!-- BEGIN: Brand -->
                        <div class="m-stack__item m-brand  m-brand--skin-{{ui.getAsideSkin()}} d-print-none"
                            style="position: relative !important;">
                            <div class="m-stack m-stack--ver m-stack--general">
                                <div class="m-stack__item m-stack__item--middle m-brand__logo" style="width:135px">
                                    <a [routerLink]="['/app/main/projects']" class="m-brand__logo-wrapper">
                                        Cable Pro {{currentYear}}
                                    </a>
                                </div>

                                <div class="m-stack__item m-stack__item--middle m-brand__tools">
                                    <!-- BEGIN: Left Aside Minimize Toggle -->
                                    <a href="javascript:;" *ngIf="ui.leftMenuUsed() && ui.allowAsideHiding() "
                                        id="m_aside_left_hide_toggle"
                                        class="m-brand__icon m-brand__toggler m-brand__toggler--left m--visible-desktop-inline-block">
                                        <!-- && isAdminUser -->
                                        <span></span>
                                    </a>
                                    <a href="javascript:;"
                                        *ngIf="ui.leftMenuUsed() && ui.allowAsideMinimizing() && !ui.allowAsideHiding() "
                                        id="m_aside_left_minimize_toggle"
                                        class="m-brand__icon m-brand__toggler m-brand__toggler--left m--visible-desktop-inline-block">
                                        <!-- && isAdminUser -->
                                        <span></span>
                                    </a>
                                    <!-- END -->
                                    <!-- BEGIN: Responsive Aside Left Menu Toggler-->
                                    <a href="javascript:;" *ngIf="ui.leftMenuUsed() " id="m_aside_left_offcanvas_toggle"
                                        class="m-brand__icon m-brand__toggler m-brand__toggler--left m--visible-tablet-and-mobile-inline-block">
                                        <!-- && isAdminUser -->
                                        <span></span>
                                    </a>
                                    <!-- END -->
                                    <a id="m_aside_header_topbar_mobile_toggle" href="javascript:;"
                                        class="m-brand__icon m--visible-tablet-and-mobile-inline-block mr-2"
                                        data-toggle="modal" data-target="#reportDlg"
                                        *ngIf="_router.url.indexOf('/maxd/') > -1 || _router.url.indexOf('/arcflash/') > -1 || _router.url.indexOf('/automaxd/') > -1 || _router.url.indexOf('/pdccalcs/') > -1 || _router.url.indexOf('/calcp/') > -1 || _router.url.indexOf('/iec-calcs/') > -1">
                                        <i class="flaticon-file" [attr.aria-label]="l('report')"
                                            style="color:#2C77E8 !important"></i>
                                    </a>

                                    <a id="m_aside_header_topbar_mobile_toggle" href="javascript:;"
                                        class="m-brand__icon m--visible-tablet-and-mobile-inline-block mr-2"
                                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                        *ngIf="_router.url.indexOf('/networkcalc/') > -1 || _router.url.indexOf('/au-calcs/') > -1 || _router.url.indexOf('/nz-calcs/') > -1 || _router.url.indexOf('/bscalcs/') > -1 || _router.url.indexOf('/nec-calcs/') > -1">
                                        <i class="flaticon-file" [attr.aria-label]="l('report')"
                                            style="color:#2C77E8 !important"></i>
                                    </a>
                                    <div class="dropdown-menu">

                                        <a *ngIf="_router.url.indexOf('/networkcalc/') > -1" class="dropdown-item"
                                            href="javascript:void(0);" data-toggle="modal" style="line-height: 1.5em;"
                                            data-target="#reportDlg">Complete Network</a>
                                        <a *ngIf="_router.url.indexOf('/networkcalc/') > -1" href="javascript:void(0);"
                                            class="dropdown-item" (click)="lvReport(2)"
                                            style="line-height: 1.5em;">Cables
                                            Schedule <img
                                                [ngClass]="_appSessionService.hasPermission(this.FeatureCode.FCSRIMEA) ? 'crown-grey' : 'crown-yellow'"
                                                class="" src="assets/cablepro/img/crown-solid.svg" height="12.27"
                                                width="12.27" alt="Premium" style="vertical-align: baseline;"></a>
                                        <a class="dropdown-item" href="javascript:void(0);"
                                            *ngIf="_router.url.indexOf('/networkcalc/') > -1 && !_settingService.hideArcFlashReport"
                                            (click)="lvReport(3)" style="line-height: 1.5em;">Arc Flash
                                            Results <img
                                                [ngClass]="_appSessionService.hasPermission(this.FeatureCode.FAFLFASR) ? 'crown-grey' : 'crown-yellow'"
                                                class="" src="assets/cablepro/img/crown-solid.svg" height="12.27"
                                                width="12.27" alt="Premium" style="vertical-align: baseline;"></a>
                                        <a class="dropdown-item" href="javascript:void(0);"
                                            *ngIf="_router.url.indexOf('/networkcalc/') > -1 && !_settingService.hideArcFlashReport"
                                            (click)="lvReport(4)" style="line-height: 1.5em;">Arc Flash
                                            Labels <img
                                                [ngClass]="_appSessionService.hasPermission(this.FeatureCode.FAFLFASR) ? 'crown-grey' : 'crown-yellow'"
                                                class="" src="assets/cablepro/img/crown-solid.svg" height="12.27"
                                                width="12.27" alt="Premium" style="vertical-align: baseline;"></a>

                                        <a *ngIf="_router.url.indexOf('/au-calcs/') > -1 || _router.url.indexOf('/nz-calcs/') > -1 || _router.url.indexOf('/bscalcs/') > -1 || _router.url.indexOf('/nec-calcs/') > -1"
                                            class="dropdown-item" href="javascript:void(0);" data-toggle="modal"
                                            usetiful_id="calcs__report-button--primary" data-target="#reportDlg">Cable
                                            Sizing</a>
                                        <a *ngIf="_router.url.indexOf('/au-calcs/') > -1 || _router.url.indexOf('/nz-calcs/') > -1 || _router.url.indexOf('/bscalcs/') > -1 || _router.url.indexOf('/nec-calcs/') > -1"
                                            class="dropdown-item" href="javascript:void(0);"
                                            (click)="lvReport(5)">Calculation Steps <img
                                                [ngClass]="_appSessionService.hasPermission(this.FeatureCode.FDCSCSIS) ? 'crown-grey' : 'crown-yellow'"
                                                class="" src="assets/cablepro/img/crown-solid.svg" height="12.27"
                                                width="12.27" alt="Premium" style="vertical-align: baseline;"></a>



                                    </div>

                                    <!-- <a id="m_aside_header_topbar_mobile_toggle" href="javascript:;"
                                    class="m-brand__icon m--visible-tablet-and-mobile-inline-block mr-2"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                    *ngIf="">
                                    <i class="flaticon-file" [attr.aria-label]="l('report')"
                                        style="color:#2C77E8 !important"></i>
                                </a>
                                <div class="dropdown-menu">
                                    
                                </div> -->


                                    <a class="m-brand__icon m--visible-tablet-and-mobile-inline-block subscription-button"
                                        *ngIf="!isAdminUser && (!isAnnualProfessionalPlan) && !(_router.url.indexOf('/pricing') > -1)">
                                        <button class="btn plan-upgrade-btn" type="button" (click)="UpgradePlan()">
                                            <img src="assets/cablepro/img/crown-solid.svg" height="13" width="13"
                                                alt="Premium">
                                        </button>
                                    </a>
                                    <a href="javascript:;" *ngIf="ui.topMenuUsed()"
                                        id="m_aside_header_menu_mobile_toggle"
                                        class="m-brand__icon m-brand__toggler m--visible-tablet-and-mobile-inline-block">
                                        <span></span>
                                    </a>
                                    <div class="m-brand__icon m--visible-tablet-and-mobile-inline-block"
                                        *ngIf="!(_router.url.indexOf('/au-calcs/') > -1 || _router.url.indexOf('/nz-calcs/') > -1 || _router.url.indexOf('/maxd/') > -1 || _router.url.indexOf('/networkcalc/') > -1 || _router.url.indexOf('/arcflash/') > -1 || _router.url.indexOf('/automaxd/') > -1 || _router.url.indexOf('/bscalcs/') > -1 || _router.url.indexOf('/pdccalcs/') > -1 || _router.url.indexOf('/settings') > -1 || _router.url.indexOf('/calcp/') > -1 || _router.url.indexOf('/pricing') > -1 || _router.url.indexOf('/iec-calcs/') > -1 || _router.url.indexOf('/nec-calcs/') > -1)">
                                        <a href="https://elek.com/tutorials/cable-pro-web/" target="_blank"
                                            class="btn btn-secondary video-tutorial">
                                            Video Tutorials <i class="fa fa-external-link"
                                                style="color: #2C77E8 !important;"></i>
                                        </a>
                                    </div>
                                    <!-- end::Responsive Header Menu Toggler-->
                                    <!-- BEGIN: Topbar Toggler -->
                                    <a id="m_aside_header_topbar_mobile_toggle" href="javascript:;"
                                        class="m-brand__icon m--visible-tablet-and-mobile-inline-block">
                                        <i class="flaticon-more" [attr.aria-label]="l('Expand')"></i>
                                    </a>
                                    <!-- BEGIN: Topbar Toggler -->
                                </div>
                                <!-- <div class="m--visible-tablet-and-mobile-inline-block">
                            <ul>
                        <li class="m-menu__item" style="padding:10px 0;">
                            
                        </li>
                    </ul>
                    </div> -->
                            </div>
                        </div>
                        <!-- END: Brand -->
                        <div style="padding-left: 0px !important;justify-content: space-between;"
                            class="m-stack__item m-stack__item--fluid m-header-head m-brand--skin-{{ui.getHeaderSkin()}} d-print-none"
                            [ngClass]="{'d-flex': isRouteMatching('/app\/main\/projects\/(\\d+)\/calcs\\?name=') || _router.url.indexOf('/cablesizing/') > -1 ||  _router.url.indexOf('/au-calcs/') > -1 || _router.url.indexOf('/nz-calcs/') > -1 || _router.url.indexOf('/maxd/') > -1 || _router.url.indexOf('/automaxd/') > -1 || _router.url.indexOf('/arcflash/') > -1 || _router.url.indexOf('/bscalcs/') > -1 || _router.url.indexOf('/pdccalcs/') > -1 || _router.url.indexOf('/calcp/') > -1 || _router.url.indexOf('/networkcalc/') > -1 || _router.url.indexOf('/iec-calcs/') > -1 || _router.url.indexOf('/nec-calcs/') > -1}"
                            id="m_header_nav">
                            <!-- BEGIN: Topbar -->
                            <div class="m-header-menu" style="margin: 0 !important;padding: 15px 0 !important;">
                                <nav class="m-header-menu" style="margin: 0 !important;">
                                    <ul class="m-menu__nav">
                                        <li class="d-flex" style="gap:0.5rem">
                                            <button usetiful_id="Install_App-button--primary"
                                                *ngIf="!pwa.isInStandaloneMode() && ((context.browser != 'chrome' && context.browser != 'edge') || (context.browser == 'chrome' && (context.os == 'ios' || context.os == 'macos')) || pwa.canInstall == true)"
                                                class="btn btn-primary pwaInstallApp"
                                                (click)="openInstallPopup()">Install
                                                App</button>
                                            <button
                                                *ngIf="!isAdminUser && (!isAnnualProfessionalPlan) && !(_router.url.indexOf('/pricing') > -1)"
                                                class="btn ml-0 plan-upgrade-btn" (click)="UpgradePlan()">
                                                <img class="mr-1" src="assets/cablepro/img/crown-solid.svg" height="14"
                                                    width="22" alt="Premium">
                                                Upgrade Your Plan
                                            </button>
                                            <a *ngIf="_router.url.indexOf('/cablesizing/') > -1 ||  _router.url.indexOf('/maxd/') > -1 || _router.url.indexOf('/automaxd/') > -1 || _router.url.indexOf('/arcflash/') > -1 || _router.url.indexOf('/pdccalcs/') > -1 || _router.url.indexOf('/calcp/') > -1 || _router.url.indexOf('/iec-calcs/') > -1"
                                                class="btn multiActionIcon ml-0" id="rpeort-btn" href="javascript:void;"
                                                usetiful_id="calcs__report-button--primary" data-toggle="modal"
                                                [class.disabled]="isReportDisabled" data-target="#reportDlg">
                                                <i class="flaticon-file"></i> Report
                                            </a>

                                            <div class="btn-group ml-0 theme-custom"
                                                *ngIf="_router.url.indexOf('/networkcalc/') > -1">
                                                <a class="dropdown-toggle btn multiActionIcon theme-custom-btn"
                                                    href="javascript:void;" data-toggle="dropdown" aria-haspopup="true"
                                                    [class.disabled]="isReportDisabled" aria-expanded="false">
                                                    <i class="flaticon-file"></i> Reports
                                                </a>
                                                <div class="dropdown-menu">
                                                    <a class="dropdown-item" href="javascript:void(0);"
                                                        data-toggle="modal" data-target="#reportDlg">Complete
                                                        Network</a>
                                                    <a class="dropdown-item" href="javascript:void(0);"
                                                        (click)="lvReport(2)">Cables Schedule <img
                                                            [ngClass]="_appSessionService.hasPermission(this.FeatureCode.FCSRIMEA) ? 'crown-grey' : 'crown-yellow'"
                                                            class="" src="assets/cablepro/img/crown-solid.svg"
                                                            height="12.27" width="12.27" alt="Premium"
                                                            style="vertical-align: baseline;"></a>
                                                    <a class="dropdown-item" href="javascript:void(0);"
                                                        *ngIf="!_settingService.hideArcFlashReport"
                                                        (click)="lvReport(3)">Arc
                                                        Flash
                                                        Results <img
                                                            [ngClass]="_appSessionService.hasPermission(this.FeatureCode.FAFLFASR) ? 'crown-grey' : 'crown-yellow'"
                                                            class="" src="assets/cablepro/img/crown-solid.svg"
                                                            height="12.27" width="12.27" alt="Premium"
                                                            style="vertical-align: baseline;"></a>
                                                    <a class="dropdown-item" href="javascript:void(0);"
                                                        *ngIf="!_settingService.hideArcFlashReport"
                                                        (click)="lvReport(4)">Arc
                                                        Flash Labels <img
                                                            [ngClass]="_appSessionService.hasPermission(this.FeatureCode.FAFLFASR) ? 'crown-grey' : 'crown-yellow'"
                                                            class="" src="assets/cablepro/img/crown-solid.svg"
                                                            height="12.27" width="12.27" alt="Premium"
                                                            style="vertical-align: baseline;"></a>
                                                </div>
                                            </div>
                                            <div class="btn-group ml-0 theme-custom"
                                                *ngIf="_router.url.indexOf('/au-calcs/') > -1 || _router.url.indexOf('/nz-calcs/') > -1 || _router.url.indexOf('/bscalcs/') > -1 || _router.url.indexOf('/nec-calcs/') > -1">
                                                <a class="dropdown-toggle btn multiActionIcon theme-custom-btn"
                                                    href="javascript:void;" data-toggle="dropdown" aria-haspopup="true"
                                                    [class.disabled]="isReportDisabled" aria-expanded="false">
                                                    <i class="flaticon-file"></i> Reports
                                                </a>


                                                <div class="dropdown-menu">
                                                    <a class="dropdown-item" href="javascript:void(0);"
                                                        data-toggle="modal" usetiful_id="calcs__report-button--primary"
                                                        data-target="#reportDlg">Cable Sizing</a>
                                                    <a class="dropdown-item" href="javascript:void(0);"
                                                        (click)="lvReport(5)">Calculation Steps <img
                                                            [ngClass]="_appSessionService.hasPermission(this.FeatureCode.FDCSCSIS) ? 'crown-grey' : 'crown-yellow'"
                                                            class="" src="assets/cablepro/img/crown-solid.svg"
                                                            height="12.27" width="12.27" alt="Premium"
                                                            style="vertical-align: baseline;"></a>


                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                            <div style="margin: 0 auto;display: flex;align-items: center;"
                                [ngClass]="{'center-loader': _settingService.IsWebFacing}"
                                [ngStyle]="{'height': _settingService.IsWebFacing ? '70px' : 'unset' }"
                                *ngIf="!isRouteMatching('/app\/main\/projects\/(\\d+)\/calcs\\?name=') && !(_router.url.indexOf('/au-calcs/') > -1 || _router.url.indexOf('/nz-calcs/') > -1 ||  _router.url.indexOf('/maxd/') > -1 || _router.url.indexOf('/automaxd/') > -1 || _router.url.indexOf('/arcflash/') > -1 || _router.url.indexOf('/bscalcs/') > -1 || _router.url.indexOf('/pdccalcs/') > -1 || _router.url.indexOf('/calcp/') > -1 || _router.url.indexOf('/networkcalc/') > -1 || _router.url.indexOf('/iec-calcs/') > -1 || _router.url.indexOf('/nec-calcs/') > -1)">
                                <angular-loader></angular-loader>
                            </div>
                            <div class="d-flex m-header-menu hide-mobile calc-popover-btn"
                                style="justify-content: center;padding: 22px 0 !important;overflow: hidden;width: inherit;"
                                *ngIf="_router.url.indexOf('/au-calcs/') > -1 || _router.url.indexOf('/nz-calcs/') > -1 ||  _router.url.indexOf('/maxd/') > -1 || _router.url.indexOf('/automaxd/') > -1 || _router.url.indexOf('/arcflash/') > -1 || _router.url.indexOf('/bscalcs/') > -1 || _router.url.indexOf('/pdccalcs/') > -1 || _router.url.indexOf('/calcp/') > -1 || _router.url.indexOf('/networkcalc/') > -1 || _router.url.indexOf('/iec-calcs/') > -1 || _router.url.indexOf('/nec-calcs/') > -1">
                                <div
                                    class="filename_view--pageTitle--3u6np text--fontNeg14--TmjQA text--_fontBase--VaHfk">
                                    <angular-loader></angular-loader>
                                    <div class="filename_view--folder--iZYVV" title="{{projectNamePristine}}">
                                        <div
                                            class="filename_view--folderNameInteractive---ALAG filename_view--folderName--Q2b88 ellipsis--ellipsis--70pHK">
                                            <a [routerLink]="['/app/main/projects/',ProjectIdPristine,'calcs']"
                                                [queryParams]="{name:projectNamePristine}">
                                                {{projectNamePristine}}
                                            </a>
                                        </div>
                                        <span class="svg-container filename_view--pathSeparator--vS7s3"
                                            aria-hidden="true">/</span>
                                    </div>
                                    <span [popoverOnHover]="false" (onShown)="onPopoverShown()"
                                        *ngIf="CalculationNamePristine" ngxSmartPopover [popover]="calculationPopover"
                                        popoverSize="medium" [popoverAnimation]="true"
                                        [popoverCloseOnClickOutside]="true" (onHidden)="onCalculationPopoverHidden()"
                                        class="filename_view--titleWithToggleContainer--aXP2c filename_view--title--Qhcgs ellipsis--ellipsis--70pHK">{{CalculationNamePristine}}</span>
                                    <div class="filename_view--chevronNoMainContainer--g-pUb" [popoverOnHover]="false"
                                        (onShown)="onPopoverShown()" *ngIf="CalculationNamePristine" ngxSmartPopover
                                        [popover]="calculationPopover" popoverSize="medium" [popoverAnimation]="true"
                                        [popoverCloseOnClickOutside]="true" (onHidden)="onCalculationPopoverHidden()">
                                        <div
                                            class="chevron--chevronContainer---Ptps  filename_view--chevronNoMainBadge--GUGD9 filename_view--chevron--NjO0h">
                                            <span
                                                class="svg-container chevron--svgChevron--tJ3pf filename_view--chevronSVG--w6pal"><i
                                                    class="fa fa-chevron-down"></i></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex m-header-menu hide-mobile project-popover-btn"
                                style="justify-content: center;padding: 24px 0 24px 15px !important;overflow: hidden;align-items: center;"
                                *ngIf="isRouteMatching('/app\/main\/projects\/(\\d+)\/calcs\\?name=')">
                                <angular-loader></angular-loader>
                                <label [popoverOnHover]="false" (onShown)="onPopoverShown()" *ngIf="projectNamePristine"
                                    ngxSmartPopover [popover]="projectPopover" popoverSize="medium"
                                    [popoverAnimation]="true" [popoverCloseOnClickOutside]="true"
                                    (onHidden)="onProjectPopoverHidden()">
                                    {{projectNamePristine}}
                                    <i class="fa fa-chevron-down"></i>
                                </label>
                            </div>
                            <div id="m_header_topbar" class="m-topbar m-stack m-stack--ver m-stack--general"
                                style="padding: 15px 0;justify-content: flex-end;">
                                <div class="flex-gap-half">
                                    <div class="help-link standards-link"
                                        *ngIf="calculationStandard === 0 || calculationStandard === 1">
                                        <button appPermission="{{FeatureCode.FATSNOAS}}" appPermissionMode="alert"
                                            appPermissionAlertTitle="Access to Standards"
                                            appPermissionAlertMessage="You can access the latest electrical standards by subscribing to a PREMIUM or PROFESSIONAL annual plan."
                                            (click)="standardAccess()" [disabled]="standardAccessApiloader"
                                            class="btn btn-secondary video-tutorial w-100">

                                            <img [ngClass]="_appSessionService.hasPermission(this.FeatureCode.FATSNOAS) ? 'crown-grey' : 'crown-yellow'"
                                                class="mr-1" src="assets/cablepro/img/crown-solid.svg" height="14.3"
                                                width="14.29" alt="Premium" style="vertical-align: text-top;">
                                            Standards Access <i *ngIf="!standardAccessApiloader"
                                                class="fa fa-external-link" style="color: #2C77E8 !important;"></i>
                                            <i *ngIf="standardAccessApiloader" class="fa fa-spinner fa-spin"
                                                style="color: #2C77E8 !important;"></i>
                                        </button>
                                    </div>
                                    <div class="help-link help-adjust prod-tour" *ngIf="!hasPlanExpired">
                                        <button id="root__tour-button" class="btn btn-secondary video-tutorial">
                                            {{buttonText}}
                                        </button>
                                    </div>
                                    <div class="help-link help-adjust vid-tut">
                                        <a href="https://elek.com/tutorials/cable-pro-web/" target="_blank"
                                            class="btn btn-secondary video-tutorial">
                                            Video Tutorials <i class="fa fa-external-link"
                                                style="color: #2C77E8 !important;"></i>
                                        </a>
                                    </div>
                                    <div class="help-link help-adjust theme-custom">
                                        <a class="btn btn-secondary help-link help-adjust dropdown-toggle" type="button"
                                            id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                            aria-expanded="false" style="color: #2C77E8 !important;
                            display: table-cell;
                            vertical-align: middle;
                            font-size: .9rem;">
                                            <i class="fa fa-question-circle" style="color: #2C77E8 !important;"></i>
                                            Help
                                        </a>
                                        <div class="dropdown-menu theme-custom" style="min-width:12.5rem !important;"
                                            aria-labelledby="dropdownMenuButton">
                                            <!-- https://elek.com/help/cable-pro-web/ -->
                                            <a class="dropdown-item" href="javascript:void(0);"
                                                (click)="OpenHelpUrl()"><i class="fa fa-book"
                                                    style="width: 14.31px;"></i>
                                                Documentation</a>
                                            <a class="dropdown-item" href="https://elek.com/tutorials/"
                                                target="_blank"><i class="fa fa-play-circle-o"
                                                    style="width: 14.31px;"></i> Video
                                                Tutorials</a>
                                            <a class="dropdown-item"
                                                href="https://support.elek.com/support/solutions/27000036930"
                                                target="_blank"><i class="fa fa-question-circle"
                                                    style="width: 14.31px;"></i>
                                                F.A.Q </a>
                                            <a appPermission="{{FeatureCode.FTSEPECH}}" appPermissionMode="alert"
                                                class="dropdown-item clscontactsupport" href="javascript:void(0);"
                                                (click)="contactSupport()"><i class="fa fa-envelope-o"></i> Contact
                                                Support
                                                <img [ngClass]="_appSessionService.hasPermission(this.FeatureCode.FTSEPECH) ? 'crown-grey' : 'crown-yellow'"
                                                    class="mr-1" src="assets/cablepro/img/crown-solid.svg"
                                                    height="14.31" width="14" alt="Premium"
                                                    style="vertical-align: revert-layer;"> </a>
                                            <a class="dropdown-item" style="padding:.7rem 1.4rem"
                                                (click)="FeatureRequest()" href="javascript:void(0);"><i
                                                    class="fa fa-lightbulb-o" style="width: 13px;"></i> Feature
                                                Request</a>
                                            <a class="dropdown-item" href="javascript:void(0);" (click)="reportBug()"><i
                                                    class="fa fa-bug" style="width: 14.31px;"></i>
                                                Report a Bug</a>
                                        </div>
                                    </div>
                                </div>
                                <nav class="m-stack__item m-topbar__nav-wrapper" style="margin-left:auto"
                                    [attr.aria-label]="l('TopMenu')">
                                    <ul class="m-topbar__nav m-nav m-nav--inline" aria-label="TopMenu" role="menubar"
                                        style="margin: 0 0px !important;display: flex;align-items: center;">
                                        <li usetiful_id="Install_App-button--primary"
                                            style="display: flex; align-items: center;"
                                            *ngIf="!pwa.isInStandaloneMode() && ((context.browser != 'chrome' && context.browser != 'edge') || (context.browser == 'chrome' && (context.os == 'ios' || context.os == 'macos')) || pwa.canInstall == true)">
                                            <a href="javascript:;"
                                                class="btn btn-primary pwaInstallApp m--visible-tablet-and-mobile-inline-block"
                                                (click)="openInstallPopup()"
                                                style="vertical-align: middle !important;font-size: 0.9rem !important;margin:0 5px;">
                                                Install
                                            </a>
                                        </li>
                                        <li headerNotifications data-dropdown-toggle="click"
                                            class="m-nav__item m-topbar__notifications m-topbar__notifications--img m-dropdown m-dropdown--large m-dropdown--header-bg-fill m-dropdown--arrow m-dropdown--align-right 	m-dropdown--mobile-full-width">
                                        </li>
                                        <li class="m-nav__item m-topbar__user-profile m-topbar__user-profile--img  m-dropdown m-dropdown--medium m-dropdown--arrow m-dropdown--header-bg-fill m-dropdown--align-right m-dropdown--mobile-full-width m-dropdown--skin-light"
                                            data-dropdown-toggle="click">

                                            <a href="javascript:;" class="m-nav__link m-dropdown__toggle"
                                                role="menuitem" aria-haspopup="true" aria-expanded="false" tabindex="0"
                                                style="color:#2c77e8;display: flex !important;align-items: center !important;justify-content: center !important;">
                                                <!-- <span class="m-topbar__username m--font-primary"
                                                style="color:#2c77e8 !important">
                                                <i *ngIf="isImpersonatedLogin" class="fa fa-reply m--font-danger"></i>
                                                <span *ngIf="isMultiTenancyEnabled"
                                                    class="tenancy-name">{{tenancyName}}\</span>{{userName}}
                                            </span> -->
                                                <span class="m-topbar__userpic">
                                                    <img *ngIf="profilePicture" alt=""
                                                        class="header-profile-picture m--img-rounded m--marginless m--img-centered"
                                                        height="34" [src]="profilePicture" />
                                                </span>
                                            </a>
                                            <div class="m-dropdown__wrapper">
                                                <span
                                                    class="m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust"></span>
                                                <div class="m-dropdown__inner">
                                                    <div class="m-dropdown__header m--align-center"
                                                        [ngStyle]="{ 'background': 'rgb(44, 119, 232)','background-size': 'cover'}">
                                                        <div class="m-card-user m-card-user--skin-dark">
                                                            <div class="m-card-user__pic">
                                                                <img alt=""
                                                                    class="header-profile-picture m--img-rounded m--marginless m--img-centered"
                                                                    [src]="profilePicture" />
                                                            </div>
                                                            <div class="m-card-user__details">
                                                                <span class="m-card-user__name m--font-weight-500">
                                                                    Welcome&nbsp;{{shownLoginName}}
                                                                </span>
                                                                <span *ngIf="userStripeSubscriptionStatus !== ''">
                                                                    <span
                                                                        *ngIf="!isAdminUser && premiumUser && isPlanActive"
                                                                        style="color:white;font-size:smaller;font-weight:normal;">
                                                                        Subscribed Plan<br />
                                                                        {{userStripePlanName}}<br />
                                                                        <span class="d-block clearfix"
                                                                            *ngIf="user && user.companyId > 0">{{user.companyName}}
                                                                            - {{user.role}}</span>
                                                                        <span style="color:aqua;">
                                                                            {{user?.isTrialing ? 'trialing':
                                                                            userStripeSubscriptionStatus}}
                                                                        </span><br />
                                                                        Renews on - {{expirationDate}}
                                                                    </span>
                                                                    <span
                                                                        *ngIf="!isAdminUser && premiumUser && !isPlanActive"
                                                                        style="color:white;font-size:smaller;font-weight:normal;">
                                                                        Subscribed Plan<br />
                                                                        {{userStripePlanName}}<br />
                                                                        <span class="d-block clearfix"
                                                                            *ngIf="user && user.companyId > 0">{{user.companyName}}
                                                                            - {{user.role}}</span>
                                                                        <span style="color:silver;">
                                                                            {{userStripeSubscriptionStatus}}
                                                                        </span><br />
                                                                        Expired on - {{expirationDate}}
                                                                    </span>
                                                                </span>
                                                                <span
                                                                    *ngIf="!isAdminUser && premiumUser && isPlanAddedManually && userStripeSubscriptionStatus === ''">
                                                                    <span *ngIf="hasPlanExpired"
                                                                        style="color:white;font-size:smaller;font-weight:normal;">
                                                                        Subscribed Plan<br />
                                                                        {{userStripePlanName}}<br />
                                                                        <span class="d-block clearfix"
                                                                            *ngIf="user && user.companyId > 0">{{user.companyName}}
                                                                            - {{user.role}}</span>
                                                                        <span style="color:silver;">
                                                                            Inactive
                                                                        </span><br />
                                                                        Expired on - {{expirationDate}}
                                                                    </span>
                                                                    <span *ngIf="!hasPlanExpired"
                                                                        style="color:white;font-size:smaller;font-weight:normal;">
                                                                        Subscribed Plan<br />
                                                                        {{userStripePlanName}}<br />
                                                                        <span class="d-block clearfix"
                                                                            *ngIf="user && user.companyId > 0">{{user.companyName}}
                                                                            - {{user.role}}</span>
                                                                        <span style="color:aqua;">
                                                                            Active
                                                                        </span><br />
                                                                        Expires on - {{expirationDate}}
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="m-dropdown__body">
                                                        <nav class="m-dropdown__content"
                                                            [attr.aria-label]="l('UserAccount')">
                                                            <ul class="m-nav m-nav--skin-light"
                                                                [attr.aria-label]="l('UserAccount')" role="menu">
                                                                <li class="m-nav__item" role="none"
                                                                    *ngIf="calculationUsageStats$ | async as calculationUsageStats">
                                                                    <div>
                                                                        <div class="justify-content-between align-items-center mb-1"
                                                                            style="display: flex;">
                                                                            <span
                                                                                class="m--font-boldest">{{calculationUsageStats.calculationUsed}}
                                                                                of
                                                                                {{calculationUsageStats.calculationLimit}}
                                                                                calculations created</span>
                                                                            <span
                                                                                class="text-muted small">{{calculationUsageStats.remaining}}
                                                                                left</span>
                                                                        </div>
                                                                        <div class="progress m-progress--sm">
                                                                            <div class="progress-bar" role="progressbar"
                                                                                [ngClass]="getProgressColor(calculationUsageStats)"
                                                                                [style.width.%]="(calculationUsageStats.calculationUsed / calculationUsageStats.calculationLimit) * 100"
                                                                                [attr.aria-valuenow]="calculationUsageStats.calculationUsed"
                                                                                [attr.aria-valuemin]="0"
                                                                                [attr.aria-valuemax]="calculationUsageStats.calculationLimit">
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="mt-3">
                                                                        <div class="justify-content-between align-items-center mb-1"
                                                                            style="display: flex;">
                                                                            <span
                                                                                class="m--font-boldest">{{calculationUsageStats.dllCallUsed}}
                                                                                of
                                                                                {{calculationUsageStats.dllCallLimit}}
                                                                                calculation credits used</span>
                                                                            <span
                                                                                class="text-muted small">{{calculationUsageStats.dllCallRemaining}}
                                                                                left</span>
                                                                        </div>
                                                                        <div class="progress m-progress--sm">
                                                                            <div class="progress-bar" role="progressbar"
                                                                                [ngClass]="getDllUsageProgressColor(calculationUsageStats)"
                                                                                [style.width.%]="(calculationUsageStats.dllCallUsed / calculationUsageStats.dllCallLimit) * 100"
                                                                                [attr.aria-valuenow]="calculationUsageStats.dllCallUsed"
                                                                                [attr.aria-valuemin]="0"
                                                                                [attr.aria-valuemax]="calculationUsageStats.dllCallLimit">
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                                <li class="m-nav__separator m-nav__separator--fit"
                                                                    role="none"></li>
                                                                <li *ngIf="isImpersonatedLogin" class="m-nav__item"
                                                                    role="none">
                                                                    <a href="javascript:;" class="m-nav__link"
                                                                        (click)="backToMyAccount()" role="menuitem"
                                                                        aria-haspopup="true" aria-expanded="false"
                                                                        tabindex="-1">
                                                                        <i
                                                                            class="m-nav__link-icon fa fa-reply m--font-danger"></i>
                                                                        <span class="m-nav__link-title">
                                                                            <span class="m-nav__link-wrap">
                                                                                <span
                                                                                    id="UserProfileBackToMyAccountButton"
                                                                                    class="m-nav__link-text">
                                                                                    {{l("BackToMyAccount")}}
                                                                                </span>
                                                                            </span>
                                                                        </span>
                                                                    </a>
                                                                </li>
                                                                <!-- <li *ngIf="isImpersonatedLogin"
                                                                class="m-nav__separator m-nav__separator--fit"
                                                                role="none"></li> -->
                                                                <!-- <li class="m-nav__separator m-nav__separator--fit"
                                                                role="none"></li> -->
                                                                <li class="m-nav__item" role="none">
                                                                    <a href="javascript:;" class="m-nav__link"
                                                                        (click)="changeProfilePicture()" role="menuitem"
                                                                        aria-haspopup="true" aria-expanded="false"
                                                                        tabindex="-1">
                                                                        <i
                                                                            class="m-nav__link-icon flaticon-profile-1"></i>
                                                                        <span class="m-nav__link-title">
                                                                            <span class="m-nav__link-wrap">
                                                                                <span id="UserProfileChangePictureLink"
                                                                                    class="m-nav__link-text">
                                                                                    {{l("ChangeProfilePicture")}}
                                                                                </span>
                                                                            </span>
                                                                        </span>
                                                                    </a>
                                                                </li>
                                                                <li class="m-nav__item" role="none">
                                                                    <a href="javascript:;" class="m-nav__link"
                                                                        [routerLink]="['/app/main/manage-account']"
                                                                        role="menuitem" aria-haspopup="true"
                                                                        aria-expanded="false" tabindex="-1">
                                                                        <i
                                                                            class="m-nav__link-icon flaticon-cogwheel"></i>
                                                                        <span class="m-nav__link-title">
                                                                            <span class="m-nav__link-wrap">
                                                                                <span id="manage-account"
                                                                                    class="m-nav__link-text">
                                                                                    Manage account
                                                                                </span>
                                                                            </span>
                                                                        </span>
                                                                    </a>
                                                                </li>
                                                                <li class="m-nav__item" role="none"
                                                                    *ngIf="user && user.premiumUser && (user.companyId <= 0 || user.isAccountOwner || user.isBillingManager)">
                                                                    <!-- <li class="m-nav__item" role="none" *ngIf="user && user.userStripeCustomerId && (user.companyId <= 0 || user.isAccountOwner || user.isBillingManager)"> -->
                                                                    <a href="javascript:;" class="m-nav__link"
                                                                        role="menuitem" aria-haspopup="true"
                                                                        aria-expanded="false" tabindex="-1"
                                                                        (click)="ManageSub()">
                                                                        <i
                                                                            class="m-nav__link-icon flaticon-calendar"></i>
                                                                        <span class="m-nav__link-title">
                                                                            <span class="m-nav__link-wrap">
                                                                                <span id="manage-account"
                                                                                    class="m-nav__link-text">
                                                                                    Manage subscription
                                                                                </span>
                                                                            </span>
                                                                        </span>
                                                                    </a>
                                                                </li>
                                                                <li class="m-nav__item" role="none"
                                                                    *ngIf="user && user.companyId <= 0 && user.premiumUser">
                                                                    <a href="javascript:;" class="m-nav__link"
                                                                        role="menuitem" aria-haspopup="true"
                                                                        aria-expanded="false" tabindex="-1"
                                                                        (click)="CreateTeamAccount()">
                                                                        <i class="m-nav__link-icon flaticon-users"></i>
                                                                        <span class="m-nav__link-title">
                                                                            <span class="m-nav__link-wrap">
                                                                                <span id="manage-account"
                                                                                    class="m-nav__link-text">
                                                                                    Create a team account
                                                                                </span>
                                                                            </span>
                                                                        </span>
                                                                    </a>
                                                                </li>
                                                                <li class="m-nav__separator m-nav__separator--fit"
                                                                    role="none"></li>
                                                                <li class="m-nav__item" role="none">
                                                                    <a href="javascript:;" (click)="logout()"
                                                                        class="btn m-btn--pill btn-secondary m-btn m-btn--custom m-btn--label-brand m-btn--bolder"
                                                                        role="menuitem" aria-haspopup="true"
                                                                        aria-expanded="false"
                                                                        tabindex="-1">{{l("Logout")}}</a>
                                                                </li>
                                                            </ul>
                                                        </nav>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </nav>
                                <!-- </ul>
                        </nav> -->
                            </div>
                            <!-- END: Topbar -->
                        </div>

                    </div>
                </div>
            </div>
            <div class="m-header__bottom m-aside-menu--skin-{{s('App.UiManagement.Left.AsideSkin')}}"
                *ngIf="ui.topMenuUsed()">
                <top-bar-menu></top-bar-menu>
            </div>
            <div *ngIf="subscriptionStatusBarVisible()" [ngClass]="{'hidden': !subscriptionStatusBarVisible()}"
                class="alert hidden subscription-info">
                <span *ngIf="tenant.isInTrialPeriod && !subscriptionIsExpiringSoon()"
                    [innerHTML]="getTrialSubscriptionNotification()"></span>
                <a *ngIf="subscriptionIsExpiringSoon()" routerLink="/app/admin/subscription-management">
                    <span *ngIf="subscriptionIsExpiringSoon() && tenant.isInTrialPeriod"><i
                            class="fa fa-exclamation-circle"></i>
                        {{getExpireNotification("TrialExpireNotification")}}</span>
                    <span *ngIf="subscriptionIsExpiringSoon() && !tenant.isInTrialPeriod"><i
                            class="fa fa-exclamation-circle"></i>
                        {{getExpireNotification("SubscriptionExpireNotification")}}</span>
                </a>
            </div>
        </header>
        <loginAttemptsModal #loginAttemptsModal></loginAttemptsModal>
        <linkedAccountsModal #linkedAccountsModal (modalClose)="getRecentlyLinkedUsers()"></linkedAccountsModal>
        <!-- <changePasswordModal #changePasswordModal></changePasswordModal> -->
        <changeProfilePictureModal #changeProfilePictureModal></changeProfilePictureModal>
        <!-- <mySettingsModal #mySettingsModal (modalSave)="onMySettingsModalSaved()"></mySettingsModal> -->
        <notificationSettingsModal #notificationSettingsModal></notificationSettingsModal>
        <div id="contactusDlg" class="modal fade" tabindex="-1" role="dialog"
            style="display:none;z-index: 1051;background-color: rgba(0, 0, 0, 0.3);">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5>Contact Support</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">�</span>
                        </button>
                    </div>
                    <div class="modal-body" [formGroup]="contactForm">
                        <div class="form-group">
                            <label class="required-field" for="exampleInputSubject">Your email address </label>
                            <input type="email" formControlName="emailcontactus" class="form-control"
                                (keypress)="keyPressContactEmail()" id="exampleInputEmail" aria-describedby="emailHelp"
                                placeholder="Enter email" required>
                            <!-- <span class="text-danger">{{contactemailreq}}</span> -->
                            <!-- <small id='emailvalidationcform' *ngIf="contactForm.get('emailcontactus').invalid && contactForm.get('emailcontactus').touched"  class="text-danger"><br/>Enter valid email.</small> -->
                            <label style="color: red" class="ng-tns-c4-1 ng-star-inserted" id='emailvalidationcform'
                                *ngIf="contactForm.get('emailcontactus').invalid && contactForm.get('emailcontactus').touched">Enter
                                valid email.</label>
                            <br *ngIf="contactemailreq">
                            <label style="color: red" class="ng-tns-c4-1 ng-star-inserted">{{contactemailreq}}</label>

                            <!-- <small *ngIf="contactForm.get('email').invalid && contactForm.get('email').touched" class="text-danger">Email is required.</small> -->
                        </div>
                        <div class="form-group">
                            <label for="exampleInputSubject" class="required-field">Subject </label>
                            <input type="hidden" id="hdnSubjectContact">
                            <input type="text" formControlName="subjectcontact" value="Cable Pro Web Bug Report"
                                name="subjectcontact" (keypress)="keyPressContactSubject()"
                                class="form-control clssubjectcontact" placeholder="Enter subject" required>
                            <label style="color: red" class="ng-tns-c4-1 ng-star-inserted">{{contactsubreq}}</label>
                            <!-- <span class="text-danger">{{contactsubreq}}</span> -->
                            <!-- <small *ngIf="contactForm.get('subjectcontact').invalid && contactForm.get('subjectcontact').touched" class="text-danger">Subject is required.</small> -->
                        </div>
                        <div class="form-group">
                            <label for="exampleFormControlTextarea1">Question or Message</label>
                            <textarea class="form-control" formControlName="qmsgcontactus" id="exampleFormControlBody"
                                rows="4" required></textarea>
                            <!-- <small *ngIf="contactForm.get('body').invalid && contactForm.get('body').touched" class="text-danger">description is required.</small> -->
                        </div>
                        <div class="form-group">
                            <label for="exampleInputFile">File</label>
                            <div class="custom-file">
                                <input (change)="onFileSelected($event)" #attachments type="file"
                                    class="custom-file-input" name="contactFile">
                                &nbsp; &nbsp; <a href="javascript:;" (click)="removeFile()" *ngIf="hasFile"
                                    class="a-btn c-btn--secondary btn-Wizard" data-dismiss="fileinput"> Remove </a>
                                <label class="custom-file-label" for="customFile"></label>
                            </div>
                            <small class="text-dark">jpg,png,pdf (Size up to 10MB)</small>
                        </div>
                        <div class="form-group">
                            <label style="padding-right:2px;" class="">
                                <input type="checkbox" formControlName="contactSendCopy" name="contactSendCopy">
                            </label>
                            <label class="ml-2" for="formCheck">Send a copy to my email address</label>
                        </div>
                        <div class="form-group clsscreenshot">
                            <label style="padding-right:2px;" class="">
                                <input type="checkbox" formControlName="contactScreenShot" name="contactScreenShot">
                            </label>
                            <label class="ml-2" for="formCheck">Include a screenshot of the browser</label>
                        </div>
                    </div>
                    <div class="modal-footer">


                        <button type="button" class="btn" (click)="CloseModal()">Close</button>
                        <button type="button" id="sendMail" class="btn btn-primary" [disabled]="btnDisabled"
                            (click)="onSubmitEmail('contactus')">Send Email</button>
                    </div>
                </div>
            </div>
        </div>
        <div id="reportbugDlg" class="modal fade" tabindex="-1" role="dialog" style="display:none">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5>Report a Bug</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">�</span>
                        </button>
                    </div>
                    <div class="modal-body" [formGroup]="reportbugForm">
                        <div class="form-group">
                            <label for="exampleInputSubject" class="required-field">Your email address </label>
                            <input type="email" formControlName="emailreportabug" class="form-control"
                                (keypress)="keyPressReportEmail()" aria-describedby="emailHelp"
                                placeholder="Enter email" required>

                            <label style="color: red" class="ng-tns-c4-1 ng-star-inserted" id='emailvalidation'
                                *ngIf="reportbugForm.get('emailreportabug').invalid && reportbugForm.get('emailreportabug').touched">Enter
                                valid email.</label>
                            <!-- <small class="text-danger"><br>{{emailreqmsg}}</small> -->
                            <br *ngIf="emailreqmsg">
                            <label style="color: red" class="ng-tns-c4-1 ng-star-inserted"> {{emailreqmsg}}</label>
                        </div>
                        <div class="form-group">
                            <label for="exampleInputSubject" class="required-field">Subject </label>
                            <input type="text" formControlName="subjectreportabug" value="Cable Pro Web Bug Report"
                                class="form-control" (keypress)="keyPressReportSubject()" required>
                            <!-- <small *ngIf="reportbugForm.get('subjectreportabug').hasError('required') && reportbugForm.get('subjectreportabug').touched" class="text-danger">Enter Subject.</small> -->
                            <label style="color: red" class="ng-tns-c4-1 ng-star-inserted">{{subjectreqmsg}}</label>

                            <!-- <small *ngIf="contactForm.get('subject').invalid && contactForm.get('subject').touched" class="text-danger">Subject is required.</small> -->
                        </div>
                        <div class="form-group">
                            <label for="exampleInputSubject">Location of the bug </label>
                            <input type="text" formControlName="locationreportabug" class="form-control"
                                name="locationreportabug" placeholder="Enter project and calculation name">
                            <!-- <small *ngIf="contactForm.get('location').invalid && contactForm.get('location').touched" class="text-danger">project and calculation is required.</small> -->
                        </div>

                        <div id="lbllocation" class="form-group locswitch" hidden *ngIf="locationswitch">
                            <label style="padding-right:2px;" class="switch">
                                <input type="checkbox" formControlName="checkboxBugLocation" name="IsActiveBugLocation"
                                    (change)="onFlagChange()">
                                <span class="slider round"></span>
                            </label>
                            <label class="ml-2" for="formCheck">Use the current calculation</label>
                        </div>
                        <div class="form-group">
                            <label for="exampleFormControlTextarea1">Description of the bug</label>
                            <textarea class="form-control" formControlName="bodyreportabug"
                                id="exampleFormControlBodydesc" rows="4" required
                                style="white-space: pre-wrap;"></textarea>
                            <!-- <small *ngIf="contactForm.get('body').invalid && contactForm.get('body').touched" class="text-danger">description is required.</small> -->
                        </div>
                        <div class="form-group">
                            <label style="padding-right:2px;" class="">
                                <input type="checkbox" formControlName="checkboxFileReportBugEmailCopy"
                                    name="checkboxFileReportBugEmailCopy">
                            </label>
                            <label class="ml-2" for="formCheck">Send a copy to my email address</label>
                        </div>
                        <div class="form-group">
                            <label style="padding-right:2px;" class="">
                                <input type="checkbox" formControlName="checkboxFileReportBugScreenShot"
                                    name="checkboxFileReportBugScreenShot">
                            </label>
                            <label class="ml-2" for="formCheck">Include a screenshot of the browser</label>
                            <input type="hidden" formControlName="hdnimagestr" name="hdnimagestr">
                            <!-- <img style="display:none;" formControlName="imageScreenShot" src="assets/anonymouspage/icons/elek-client-TafeNSW.jpg" id="groot"> -->
                        </div>
                        <div class="form-group" *ngIf="IsActive" style="display:none;">
                            <label for="exampleInputFile">File</label>
                            <div class="custom-file">
                                <input (change)="onFileSelected($event)" type="file" class="custom-file-input"
                                    name="reportFile">
                                <label class="custom-file-label" for="customFile">Choose file</label>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn" (click)="CloseModal()">Close</button>
                        <button type="button" class="btn btn-primary" [disabled]="btnDisabled"
                            (click)="onSubmitEmail('bugreport')">
                            Send Email
                        </button>

                    </div>
                </div>
            </div>
        </div>
        <div id="HelpEmailSent" class="modal fade" role="dialog"
            style="display:none;z-index: 1052;background-color: rgba(0, 0, 0, 0.3);">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5>Email Sent</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">�</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info">
                            <p style="font-size:14px;color:white;margin:0 auto">
                                <i class="fa fa-check"></i> Your feedback has been successfully emailed.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="download" style="display:none;">
            <img #canvas>
        </div>

        <div id="feedbackPlatform" class="modal fade clscontainer" role="dialog"
            style="display:none;overflow:auto;padding-right: 0 !important;">
            <div class="modal-dialog" style="max-width: 90%;" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 style="font-family:Poppins;">New Feature Requests and Feedback</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-body" style="height: 85vh;display: grid;">
                        <div class="row">
                            <div class="col-md-12" *ngIf="feedbackUrl">
                                <iframe sandbox="allow-same-origin allow-scripts allow-top-navigation allow-forms"
                                    data-tf-redirect-target="_self" [src]="feedbackUrl" frameborder="0" style="overflow: hidden; height: 100%;
                            width: 100%;"></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="standardAccessModal" class="modal fade clscontainer" role="dialog"
            style="display:none;overflow:auto;padding-right: 0 !important;">
            <div class="modal-dialog" style="max-width: 90%;" role="document">
                <div class="modal-content">
                    <div class="modal-header d-flex align-items-baseline">
                        <h4 style="font-family:Poppins;">Download the Latest Electrical Standards — <b style="color: red;">If an error occurs, refresh your browser.</b>
                        </h4>
                        <!-- <a href="javascript:void(0);" *ngIf="!standardAccessIframeLoader"
                        (click)="requestStandardAccess()" class="d-inline ml-4 btn btn-primary">
                        Request a Standard
                    </a> -->
                        <div class="loading" style="width: fit-content;margin: 0 auto;" *ngIf="standardAccessloader">
                            Loading&#8230;</div>
                        <label [ngClass]="{'ml-auto': !standardAccessloader}" *ngIf="timeLeft > 0">This window will
                            automatically close in {{minutes}}:{{seconds}} minutes</label>
                        <button type="button" class="close ml-3" aria-label="Close" (click)="handleTimeUp()">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-body" style="height: 78vh;display: grid;">
                        <div class="row">
                            <div class="col-md-12" *ngIf="standardAccessModalVisible">
                                <div class="loader" *ngIf="standardAccessIframeLoader"></div>
                                <iframe
                                    sandbox="allow-same-origin allow-scripts allow-top-navigation allow-forms allow-popups allow-popups-to-escape-sandbox allow-downloads"
                                    allow="display-capture" data-tf-redirect-target="_self" [src]="standardAccessUrl"
                                    (load)="onIframeLoad()" frameborder="0" style="overflow: hidden; height: 100%;
                            width: 100%;"></iframe>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer d-flex justify-content-start position-relative"
                        *ngIf="!standardAccessIframeLoader">
                        <a href="javascript:void(0);" (click)="requestStandardAccess()" class="left-link">
                            Standard not found? Request it.
                        </a>

                        <button type="button" class="btn btn-primary"
                            style="position: absolute;left: 50%;transform: translateX(-50%);" (click)="handleTimeUp()"
                            data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
        <style>
            @media only screen and (max-width: 480px) {
                .m-header__top .m-brand__logo-wrapper {
                    font-size: 16px;
                }

                .m-header__top .btn {
                    padding: 5px 10px;
                    font-size: 10px;
                }

                .m-header__top .m-brand__icon {
                    margin-left: 0px !important;
                }

                #m_aside_left_offcanvas_toggle {
                    margin-right: 5px;
                }
            }


            /*    .switch {
        position: relative;
        display: inline-block;
        width: 50px;
        height: 24px;
    }
    .switch input
    { 
        opacity: 0;
        width: 0;
        height: 0;
    }

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 20px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}*/

            input:checked+.slider {
                background-color: #2196F3;
            }

            input:focus+.slider {
                box-shadow: 0 0 1px #2196F3;
            }

            /*input:checked + .slider:before {
  -webkit-transform: translateX(20px);
  -ms-transform: translateX(20px);
  transform: translateX(20px);
}*/

            /* Rounded sliders */
            .slider.round {
                border-radius: 24px;
            }

            .slider.round:before {
                border-radius: 50%;
            }

            /* .m-brand .m-brand__tools .m-brand__icon */
        </style>

    </div>
    <div class="display-mobile-only-layout calc-popover-btn"
        style="padding: 10px 10px 0px 10px !important;background: #f2f3f8;text-align: center;"
        *ngIf="_router.url.indexOf('/au-calcs/') > -1 || _router.url.indexOf('/nz-calcs/') > -1 ||  _router.url.indexOf('/maxd/') > -1 || _router.url.indexOf('/automaxd/') > -1 || _router.url.indexOf('/arcflash/') > -1 || _router.url.indexOf('/bscalcs/') > -1 || _router.url.indexOf('/pdccalcs/') > -1 || _router.url.indexOf('/calcp/') > -1 || _router.url.indexOf('/networkcalc/') > -1 || _router.url.indexOf('/iec-calcs/') > -1 || _router.url.indexOf('/nec-calcs/') > -1">
        <div class="filename_view--pageTitle--3u6np text--fontNeg14--TmjQA text--_fontBase--VaHfk">
            <angular-loader></angular-loader>
            <div class="filename_view--folder--iZYVV" title="{{projectNamePristine}}">
                <div
                    class="filename_view--folderNameInteractive---ALAG filename_view--folderName--Q2b88 ellipsis--ellipsis--70pHK">
                    <a [routerLink]="['/app/main/projects/',ProjectIdPristine,'calcs']"
                        [queryParams]="{name:projectNamePristine}">
                        {{projectNamePristine}}
                    </a>
                </div>
                <span class="svg-container filename_view--pathSeparator--vS7s3" aria-hidden="true">/</span>
            </div>
            <span [popoverOnHover]="false" (onShown)="onPopoverShown()" *ngIf="CalculationNamePristine" ngxSmartPopover
                [popover]="calculationPopover" popoverSize="medium-small" [popoverAnimation]="true"
                [popoverCloseOnClickOutside]="true" (onHidden)="onCalculationPopoverHidden()"
                class="filename_view--titleWithToggleContainer--aXP2c filename_view--title--Qhcgs ellipsis--ellipsis--70pHK">{{CalculationNamePristine}}</span>
            <div class="filename_view--chevronNoMainContainer--g-pUb" [popoverOnHover]="false"
                (onShown)="onPopoverShown()" *ngIf="CalculationNamePristine" ngxSmartPopover
                [popover]="calculationPopover" popoverSize="medium-small" [popoverAnimation]="true"
                [popoverCloseOnClickOutside]="true" (onHidden)="onCalculationPopoverHidden()">
                <div
                    class="chevron--chevronContainer---Ptps  filename_view--chevronNoMainBadge--GUGD9 filename_view--chevron--NjO0h">
                    <span class="svg-container chevron--svgChevron--tJ3pf filename_view--chevronSVG--w6pal"><i
                            class="fa fa-chevron-down"></i></span>
                </div>
            </div>
        </div>
    </div>
    <div class="display-mobile-only-layout project-popover-btn"
        style="padding: 10px 10px 0px 10px !important;background: #f2f3f8;text-align: center;"
        *ngIf="isRouteMatching('/app\/main\/projects\/(\\d+)\/calcs\\?name=') || isRouteMatching('/app\/main\/webfacing\/(\\d+)\/cablesizing\\?name=')">
        <angular-loader></angular-loader>
        <label [popoverOnHover]="false" (onShown)="onPopoverShown()" *ngIf="projectNamePristine" ngxSmartPopover
            [popover]="projectPopover" popoverSize="medium-small" [popoverAnimation]="true"
            [popoverCloseOnClickOutside]="true" (onHidden)="onProjectPopoverHidden()">
            {{projectNamePristine}}
            <i class="fa fa-chevron-down"></i>
        </label>
    </div>
    <div id="list-subscription-expired-model" class="modal fade" tabindex="-1" role="dialog" style="display:none">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div *ngIf="hasPlanExpired" class="modal-header">
                    <h5>{{expiredPlanHeadingText}}</h5>
                </div>
                <div *ngIf="!hasPlanExpired" class="modal-header">
                    <h5>{{expiredPlanHeadingText}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body">
                    <p class="popup-body-font"><label>{{expiredPlanBodyText}}</label></p>
                </div>

                <div *ngIf="hasPlanExpired" class="modal-footer">
                    <button type="button" class="btn btn-secondary" (click)="extendTrialPeriod()"
                        *ngIf="planExtendedCount < 2" [disabled]="isLoaderForExtendPlan">
                        Extend Free Trial <i *ngIf="isLoaderForExtendPlan" class="fa fa-spinner fa-spin"></i>
                    </button>
                    <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="GoToPricing()">
                        Go to
                        Pricing
                    </button>
                </div>
                <div *ngIf="!hasPlanExpired" class="modal-footer">

                    <button type="button" class="btn btn-primary btn-gotopricing" data-dismiss="modal"
                        (click)="GoToPricing()">
                        Go to
                        Pricing
                    </button>
                    <button type="button" style="display:none;" class="btn btn-primary btn-upgrade" data-dismiss="modal"
                        (click)="SetUpgradeLink()">Upgrade</button>
                    <button type="button" class="btn btn-secondary expiry" data-dismiss="modal"
                        (click)="HideExpiryPopUp()">
                        OK
                    </button>
                </div>
            </div>
        </div>
    </div>
    <popover-content #calculationPopover [animation]="true" [closeOnClickOutside]="true" class="calc-popover">
        <form (ngSubmit)="onPopoverSubmit()" (keyup.enter)="keyEnterCalculation()">
            <div class="pb-4">
                <label for="calculation-name" class="c-field__label pb-2"> Calculation name </label>
                <div>
                    <input class="form-control" id="calculationName" name="CalculationName" type="text"
                        [(ngModel)]="CalculationName" required maxlength="120" />
                </div>
            </div>
            <div>
                <label for="project-namecalculation" class="c-field__label pb-2">Project name</label>
                <div class="custom-selectbox">
                    <ng-select #select [clearable]="false" [items]="projectOutput" name="projectnamesearch"
                        bindLabel="name" [addTag]="true" [(ngModel)]="ProjectId" bindValue="id" [searchable]="true"
                        (change)="onBlur($event)">
                        <ng-template ng-tag-tmp let-search="searchTerm">
                            <b>create new</b>: {{search}}
                        </ng-template>
                        <!-- <ng-template ng-header-tmp>
                        <input placeholder="search existing or type a new project name" style="width: 100%; line-height: 24px" type="text" (input)="select.filter($event.target.value)"/>
                    </ng-template> -->
                    </ng-select>

                </div>
            </div>
        </form>
    </popover-content>
    <popover-content #projectPopover [animation]="true" [closeOnClickOutside]="true" class="proj-popover">
        <form (ngSubmit)="onPopoverSubmit()" (keyup.enter)="keyEnterProject()">
            <div>
                <label for="project-name2" class="c-field__label pb-2">Project name</label>
                <div>
                    <input class="form-control" id="txtprojectName" name="projectName" type="text"
                        [(ngModel)]="projectName" required min="1" max="120" maxlength="120" />
                </div>
            </div>
        </form>
    </popover-content>
</div>